const NotFound = () =>{
    return(
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'70vh'}}>
            <p>404 Not Found</p>
        </div>
    )
}

export default NotFound;